export const createWorker = (buildWorker: string, name?: string) => {
  const workerBlob = new Blob([buildWorker]);
  const workerUrl = URL.createObjectURL(workerBlob);
  const worker = new Worker(workerUrl, {
    name,
  });

  return worker;
};
